// True for Auth0 errors that mean the session can't be renewed silently (login required).
// Shared by the Apollo auth link and SessionExpiryWatcher so both classify expiry identically.
export const isSessionExpiredError = (err: unknown): boolean => {
  const record = typeof err === "object" && err !== null ? (err as Record<string, unknown>) : {};
  const errorCode = typeof record.error === "string" ? record.error : "";
  const errorMessage = err instanceof Error ? err.message : String(err);
  return (
    errorCode === "login_required" ||
    errorCode === "consent_required" ||
    errorMessage.includes("login_required") ||
    errorMessage.includes("consent_required")
  );
};

// Auth0 only returns undefined with cacheMode "cache-only", which we never use.
export const requireToken = (token: string | undefined): string => {
  if (token === undefined) {
    throw new Error("Auth0 returned no access token");
  }
  return token;
};
